import { render, staticRenderFns } from "./OnboardingLayout.vue?vue&type=template&id=e588905c&scoped=true"
import script from "./OnboardingLayout.vue?vue&type=script&lang=js"
export * from "./OnboardingLayout.vue?vue&type=script&lang=js"
import style0 from "./OnboardingLayout.vue?vue&type=style&index=0&id=e588905c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e588905c",
  null
  
)

export default component.exports